'use strict';

module.exports = require('./InputGroup');


//////////////////
// WEBPACK FOOTER
// ./~/bee-input-group/build/index.js
// module id = 408
// module chunks = 0